import auth from '@/middlewares/auth'
import autoLogin  from '@/middlewares/autoLogin'
import routerName from '@/constants/routers'

export default [
    {
        path: '/onboarding',
        component: () => import( /* webpackChunkName: "onboarding" */ './views/layout.vue'),
        children : [
            {
                path: '/',
                name: routerName.ONBOARD,
                meta: {
                    middleware : [ autoLogin , auth ],
                    breadcrumb: [
                        { name: 'Onboarding' },
                    ],
                    layout: 'full'
                },
                component: () => import( /* webpackChunkName: "onboarding-welcome" */ './views/welcome.vue')
            },
            {
                path: 'set-up',
                name: routerName.ONBOARD_SET_UP,
                meta: {
                    middleware : [ autoLogin , auth ],
                    breadcrumb: [
                        { name: 'Onboarding' },
                        { name: 'Onboard Set Up' },
                    ],
                    layout: 'full'
                },
                component: () => import( /* webpackChunkName: "onboarding-set-up" */ './views/set-up.vue')
            },
        ]
        
    }
]